import colors from './colors';

class EnumArray extends Array {

    /**
     *
     * @param {string} key
     * @returns {string}
     */
    getLabelByKey(key) {
        const foundItem = this.getItemByKey(key);
        return foundItem?.label;
    }

    /**
     *
     * @param {string} key
     * @returns {object}
     */
    getItemByKey(key) {
        return this.find(item => item.key === key);
    }

}

export const SITUATIONS = new EnumArray(
    {
        key: 1,
        label: 'Ativo',
    },
    {
        key: 0,
        label: 'Inativo',
    },
);

export const LOCUS_ENGINE_FUNCTION = new EnumArray(
    {
        key: 0,
        label: 'Desconhecido',
    },
    {
        key: 1,
        label: 'Passagem',
    },
    {
        key: 2,
        label: 'Monitoramento',
    },
    {
        key: 3,
        label: 'Clausura',
    },
);

export const DISPLAY_CHANNEL_MODE = new EnumArray(
    {
        key: 0,
        label: 'Câmera única',
    },
    {
        key: 1,
        label: 'Buffer de Clausura',
    },
);

export const YES_OR_NO = new EnumArray(
    {
        key: 1,
        label: 'Sim',
    },
    {
        key: 0,
        label: 'Não',
    },
);

export const FRAME_SOURCE_TYPE = new EnumArray(
    {
        key: 0,
        label: 'Desconhecido',
    },
    {
        key: 1,
        label: 'RTSP Camera',
    },
    {
        key: 2,
        label: 'Histórico',
    },
);

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5mb

export const ACCEPT_FILES = [
    'application/xls',
    'application/xlsx',
    'application/csv',
];

export const KEYCLOAK_ROLES = {
    OP_ADMIN: 'op-admin',
};

export const DEFAULT_PAGE_SIZE = 10;

export const DEFAULT_TABLE_PAGINATION = {
    page: 1,
    total: 0,
    count: 0,
    limit: DEFAULT_PAGE_SIZE,
};

export const ORDER_OPTIONS = new EnumArray(
    {
        key: 'desc',
        label: 'Mais recentes primeiro',
        item: {
            key: 'desc',
            label: 'Mais recentes primeiro',
        },
    },
    {
        key: 'asc',
        label: 'Mais antigas primeiro',
        item: {
            key: 'asc',
            label: 'Mais antigas primeiro',
        },
    },
);

export const PEOPLE_PAGE_BATCH_ACTIONS = new EnumArray(
    {
        key: 1,
        label: 'Ativar',
    },
    {
        key: 2,
        label: 'Desativar',
    },
    {
        key: 3,
        label: 'Permitir',
    },
    {
        key: 4,
        label: 'Excluir',
    },
);

export const PRINT_CSV_TYPE = new EnumArray(
    {
        key: 1,
        label: 'Relatório de Eventos',
        value: 1,
    },
    {
        key: 2,
        label: 'Relatório de Presenças',
        value: 2,
    },
);

export const DOCCUMENT_TYPES = new EnumArray(
    {
        key: 0,
        item: {
            key: 0,
            label: 'CPF / CNPJ',
            name: 'documentCPF',
        },
        label: 'CPF / CNPJ',
    },
    {
        key: 1,
        item: {
            key: 1,
            label: 'Outro Documento',
            name: 'documentOther',
        },
        label: 'Outro Documento',
    },
    {
        key: 2,
        item: {
            key: 2,
            label: 'RG',
            name: 'documentRG',
        },
        name: 'documentRG',
        label: 'RG',
    },
);

export const PERMISSIONS_TYPES = new EnumArray(
    {
        key: 0,
        label: 'Permitir',
    },
    {
        key: 1,
        label: 'Proibir',
    },
);

export const WEEKDAY_VALUES = new EnumArray(
    {
        key: 0,
        initial: 'D',
        value: 1,
        label: 'Domingo',
    },
    {
        key: 1,
        initial: 'S',
        value: 2,
        label: 'Segunda',
    },
    {
        key: 2,
        initial: 'T',
        value: 4,
        label: 'Terça',
    },
    {
        key: 3,
        initial: 'Q',
        value: 8,
        label: 'Quarta',
    },
    {
        key: 4,
        initial: 'Q',
        value: 16,
        label: 'Quinta',
    },
    {
        key: 5,
        initial: 'S',
        value: 32,
        label: 'Sexta',
    },
    {
        key: 6,
        initial: 'S',
        value: 64,
        label: 'Sábado',
    },
);

export const EVENT_TYPES = new EnumArray(
    {
        key: 0,
        label: 'Permitido',
        color: colors.colorSuccess,
    },
    {
        key: 1,
        label: 'Desconhecido',
        color: colors.colorError,
    },
    {
        key: 2,
        label: 'Desativado',
        color: colors.colorAlert,
    },
    {
        key: 3,
        label: 'Expirado',
        color: colors.colorAlert,
    },
    {
        key: 4,
        label: 'Fora de horário',
        color: colors.colorAlert,
    },
    {
        key: 5,
        label: 'Sem Reconhecimento',
        color: colors.colorNeutral,
    },
);

export const EVENT_ACTION_TYPE = new EnumArray(
    {
        key: 0,
        label: 'Sem tratamento',
        color: colors.colorError,
    },
    {
        key: 1,
        label: 'Ignorado',
        color: colors.colorError,
    },
    {
        key: 2,
        label: 'Mais semelhante aceito',
        color: colors.colorSuccess,
    },
    {
        key: 3,
        label: 'Pessoa removida',
        color: colors.colorError,
    },
    {
        key: 4,
        label: 'Identificado',
        color: colors.colorSuccess,
    },
    {
        key: 5,
        label: 'Permitido',
        color: colors.colorSuccess,
    },
    {
        key: 6,
        label: 'Reportado',
        color: colors.colorError,
    },
    {
        key: 7,
        label: 'Justificado',
        color: colors.colorError,
    },
);

export const EVENT_IGNORE_TYPE = new EnumArray(
    {
        key: 0,
        label: 'Nenhum',
    },
    {
        key: 1,
        label: 'Pessoa não passou',
    },
    {
        key: 2,
        label: 'Não é uma pessoa',
    },
    {
        key: 3,
        label: 'Registro duplicado',
    },
    {
        key: 4,
        label: 'Criança',
    },
);

export const EVENT_WAYS = new EnumArray(
    {
        key: 1,
        label: 'Entrada',
    },
    {
        key: 0,
        label: 'Saída',
    },
);

export const CHECK_IN_TYPES = new EnumArray(
    {
        key: 0,
        label: 'Aberto',
    },
    {
        key: 1,
        label: 'Restrito',
    },
    {
        key: 2,
        label: 'Oculto',
    },
);

export const EVENT_SYSTEM_TYPES = new EnumArray(
    {
        key: 0,
        label: 'Conectado',
    },
    {
        key: 1,
        label: 'Desconectado',
    },
    {
        key: 2,
        label: 'Aviso',
    },
    {
        key: 3,
        label: 'Erro',
    },
);

export const SYSTEM_COMPONENTS = new EnumArray(
    {
        key: 0,
        label: 'Core',
    },
    {
        key: 1,
        label: 'WhatsApp Module',
    },
    {
        key: 2,
        label: 'Teams Module',
    },
);

export const IS_OPEN_VALUES = new EnumArray(
    {
        key: 0,
        label: 'Fechado',
    },
    {
        key: 1,
        label: 'Aberto',
    },
);

export const YES_NO_OPTIONS = new EnumArray(
    {
        key: 0,
        label: 'Não',
    },
    {
        key: 1,
        label: 'Sim',
    },
);

export const VISION_TYPES = new EnumArray(
    {
        key: 'none',
        label: 'Nenhum',
    },
    {
        key: 'eventType',
        label: 'Tipo de evento',
    },
);

export const CHECKIN_ASSOCIATION_TYPES = new EnumArray(
    {
        key: 0,
        label: 'Anfitrião',
    },
    {
        key: 1,
        label: 'Empresa',
    },
    {
        key: 2,
        label: 'Anfitrião e empresa',
    },
);

export const AUDIO_CONFIGURATIONS = new EnumArray(
    {
        key: 'alarmAudio',
        label: 'Alarme',
    },
    {
        key: 'allowPersonAudio',
        label: 'Permitir pessoa',
    },
    {
        key: 'allowedPassedAudio',
        label: 'Pessoa permitida passou',
    },
    {
        key: 'badPoseWarningAudio',
        label: 'Aviso de pose ruim',
    },
    {
        key: 'expiredPersonAtSightAudio',
        label: 'Pessoa expirada a vista',
    },
    {
        key: 'offlineAudio',
        label: 'Offline',
    },
    {
        key: 'onlineAudio',
        label: 'Online',
    },
    {
        key: 'outOfTimeWindowsAtSightAudio',
        label: 'Pessoa fora do horário a vista',
    },
    {
        key: 'unknownPersonAtSightAudio',
        label: 'Pessoa desconhecida a vista',
    },
);

export const CAMERA_TYPES = new EnumArray(
    {
        key: 0,
        label: 'Desconhecido',
    },
    {
        key: 1,
        label: 'Câmera',
    },
);

export const CAMERA_FUNCTIONS = new EnumArray(
    {
        key: 1,
        label: 'Entrada',
    },
    {
        key: 2,
        label: 'Saída',
    },
    {
        key: 3,
        label: 'Monitoramento',
    },
);

export const PICTURE_REJECT_REASONS = new EnumArray(
    {
        key: 0,
        label: 'SEM ERRO',
    },
    {
        key: 1,
        label: 'FACE NÃO DETECTADA',
    },
    {
        key: 2,
        label: 'MÚLTIPLAS FACES',
    },
    {
        key: 3,
        label: 'POSE RUIM',
    },
    {
        key: 4,
        label: 'FACE PEQUENA',
    },
    {
        key: 5,
        label: 'DADOS DE IMAGEM INCORRETOS',
    },
    {
        key: 6,
        label: 'SEM FOTO',
    },
    {
        key: 98,
        label: 'ALGO DEU ERRADO',
    },
    {
        key: 99,
        label: 'FALHA DESCONHECIDA',
    },
);

export const DASHBOARD_OPTIONS = new EnumArray(
    {
        key: 24,
        label: '24 horas',
    },
    {
        key: 48,
        label: '48 horas',
    },
    {
        key: 7,
        label: '7 dias',
    },
    {
        key: 14,
        label: '14 dias',
    },
    {
        key: 30,
        label: '30 dias',
    },
);
